import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { GalleryApp } from "./GalleryApp.js";
import "../../web/src/theme.css";
import "../../web/src/styles.css";
import "../../web/src/observability.css";
import "../../web/src/lineage.css";
import "../../web/src/lineage-evidence.css";
import "../../web/src/report.css";
import "./gallery.css";
import "./quiet.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: false, staleTime: Number.POSITIVE_INFINITY },
    mutations: { retry: false }
  }
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <GalleryApp />
    </QueryClientProvider>
  </React.StrictMode>
);
